module.exports = __webpack_public_path__ + "img/xzwm1.945a0023.jpg";